export default __webpack_public_path__ + "static/media/3019.ee421f8e.jpg";